// extracted by extract-css-chunks-webpack-plugin
module.exports = {"suggestionHighlighted":"_3kVMkK","suggestionsContainerOpen":"nHTpX3","container":"_1zPiww","suggestionsContainer":"_9umKrr","suggestion":"_35r8Cd"};